export const SET_CART_SHIPPING_ADDRESS = 'SET_CART_SHIPPING_ADDRESS';
export const SET_CART_SELECTED_SHIPPING_ADDRESS =
  'SET_CART_SELECTED_SHIPPING_ADDRESS';
